// extracted by mini-css-extract-plugin
module.exports = {"ementas_digitais":"Modal_ementas_digitais__1D3rM","Modal":"Modal_Modal__gMPRg","chef_house":"Modal_chef_house__3HW61"};